import { Controller } from "stimulus"

// OMS-96286: botão sem permissão. O tooltip "Sem permissão" já aparece no hover (data-tooltip);
// no clique (inclusive no celular, sem hover) ele é exibido por alguns segundos.
const VISIBLE_FOR_MS = 2500

export default class extends Controller {
  show(event) {
    event.preventDefault()
    event.stopPropagation()

    this.element.classList.add("is-tooltip-open")
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.classList.remove("is-tooltip-open"), VISIBLE_FOR_MS)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
